import { render, staticRenderFns } from "./NavbarSubMenu.vue?vue&type=template&id=66cec155&scoped=true&"
import script from "./NavbarSubMenu.vue?vue&type=script&lang=js&"
export * from "./NavbarSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavbarSubMenu.vue?vue&type=style&index=0&id=66cec155&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cec155",
  null
  
)

export default component.exports